/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function BlockExpandable({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#BlockExpandable_svg__a)"><path d="M3 .9A2.6 2.6 0 0 0 .4 3.5a.6.6 0 1 0 1.2 0A1.4 1.4 0 0 1 3 2.1h10a1.4 1.4 0 0 1 1.4 1.4V6a.6.6 0 0 0 1.2 0V3.5A2.6 2.6 0 0 0 13 .9zM15.6 10a.6.6 0 1 0-1.2 0v2.5a1.4 1.4 0 0 1-1.4 1.4H3a1.4 1.4 0 0 1-1.4-1.4.6.6 0 1 0-1.2 0 2.6 2.6 0 0 0 2.598 2.6h10.004000000000001a2.6 2.6 0 0 0 2.598-2.6zM1.424 10.424l2-2a.6.6 0 0 0 0-.848l-2-2a.6.6 0 1 0-.848.848L2.152 8 .575 9.576a.6.6 0 0 0 .848.848" /><path d="M6 6.6a.6.6 0 0 1 0-1.2h6a.6.6 0 1 1 0 1.2zM5.4 10a.6.6 0 0 1 .6-.6h6a.6.6 0 1 1 0 1.2H6a.6.6 0 0 1-.6-.6" /></g><defs><clipPath id="BlockExpandable_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;